<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title" @paste="onSectionPaste">퀘스트 관리 (여기다 붙여넣으세요)</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">퀘스트타입</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="" v-model="data.type">
              <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.id" :key="option.type"></el-option>
            </el-select>
          </div>
          <label class="col-sm-2 col-form-label">카테고리</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="" v-model="data.categoryId">
              <el-option v-for="option in categories" class="select-primary" :value="option.id" :label="option.title" :key="option.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">이미지</label>
          <div class="col-sm-2">
            <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="data.imageFileId | blipImageUrl" @onChangeFileIds="onFileIdChange" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">퀘스트명</label>
          <div class="col-sm-10">
            <base-input placeholder="" v-model="data.name">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">언어별 퀘스트명</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-1 col-form-label">한국어</div>
              <div class="col-sm-10">
                <base-input placeholder="한국어">
                  <textarea class="form-control" id="content" rows="2" v-model="data.names.ko" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-1 col-form-label">영어</div>
              <div class="col-sm-10">
                <base-input placeholder="영어">
                  <textarea class="form-control" id="content" rows="2" v-model="data.names.en" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-1 col-form-label">일본어</div>
              <div class="col-sm-10">
                <base-input placeholder="일본">
                  <textarea class="form-control" id="content" rows="2" v-model="data.names.ja" />
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="data.link" />
            <base-input placeholder="이동할 링크" v-model="data.link">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">일반유저</label>
          <div class="col-sm-5">
            <div class="row">
              <label class="col-sm-2 col-form-label">별보상</label>
              <div class="col-sm-10">
                <base-input placeholder="별보상" v-model="data.star">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <label class="col-sm-2 col-form-label">포인트</label>
              <div class="col-sm-10">
                <base-input placeholder="-1일 경우 랜덤포인트" v-model="data.point">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="parseInt(data.point, 10) === -1">
          <label class="col-sm-2 col-form-label">랜덤포인트</label>
          <div class="col-sm-2">
            <base-button @click="addRandomPoint">+</base-button>
          </div>
          <div class="col-sm-8">
            <div class="row" v-for="(item, index) in data.randomPoints" :key="index">
              <div class="col-sm-2">포인트</div>
              <div class="col-sm-3">
                <base-input placeholder="" v-model="item.value">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-2">확률</div>
              <div class="col-sm-3">
                <base-input placeholder="" v-model="item.probability">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-1">
                <base-button type="danger" @click="removeRandomPoint(index)">-</base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">슈퍼블립</label>
          <div class="col-sm-5">
            <div class="row">
              <label class="col-sm-2 col-form-label">별보상</label>
              <div class="col-sm-10">
                <base-input placeholder="별보상" v-model="data.superblipStar">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <label class="col-sm-2 col-form-label">포인트</label>
              <div class="col-sm-10">
                <base-input placeholder="-1일 경우 랜덤포인트" v-model="data.superblipPoint">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-2 col-form-label">포토카드보상</label>
          <div class="col-sm-10">
            <base-input placeholder="포토카드보상" v-model="data.photoCard">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">가중치</label>
          <div class="col-sm-10">
            <base-input placeholder="" v-model="data.weight">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">시작시간</label>
          <div class="col-sm-4">
            <base-input>
              <el-date-picker type="datetime" placeholder="시작시간" v-model="data.startTime"></el-date-picker>
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">종료시간</label>
          <div class="col-sm-4">
            <base-input>
              <el-date-picker type="datetime" placeholder="종료시간" v-model="data.endTime"></el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">유저세그먼트</label>
          <div class="col-sm-4">
            <el-select class="select-primary" size="large" placeholder="세그먼트 선택" v-model="data.segment">
              <el-option v-for="segment in segments" class="select-primary" :value="segment.segment" :label="segment.text" :key="segment.segment"></el-option>
            </el-select>
          </div>
          <label class="col-sm-2 col-form-label">챌린지</label>
          <div class="col-sm-4">
            <v-select
              class="select-primary"
              size="large"
              placeholder="챌린지선택"
              :clearable="false"
              :options="challenges"
              :reduce="(label) => label.id"
              label="title"
              v-model="data.challengeId"
            >
            </v-select>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">미션 보상 간격</label>
          <div class="col-sm-2">
            <base-input placeholder="" v-model="data.count">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-2">
            <el-popover trigger="hover" placement="top">
              <div>
                <div class="popover-body">미션을 몇 번 도전해야 보상을 1번 받는지</div>
              </div>
              <base-button slot="reference"> ? </base-button>
            </el-popover>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-2 col-form-label">미션 보상 횟수</label>
          <div class="col-sm-2">
            <base-input placeholder="" v-model="data.retryCount">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-2">
            <el-popover trigger="hover" placement="top">
              <div>
                <div class="popover-body">하루에 최대 몇 번 보상 받을 수 있는지</div>
              </div>
              <base-button slot="reference"> ? </base-button>
            </el-popover>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">미션 도전 횟수</label>
          <div class="col-sm-2">
            <base-input placeholder="" v-model="data.maxCount">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-2">
            <el-popover trigger="hover" placement="top">
              <div>
                <div class="popover-body">총 몇 번 미션 도전 가능한지</div>
              </div>
              <base-button slot="reference"> ? </base-button>
            </el-popover>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import { QuestType } from "@/pages/Quest/QuestType";
import LinkSelect from "@/pages/Components/LinkSelect.vue";
import Endpoints from "@/common/Endpoints";
import BlipFileUploadZone from "@/components/BlipFileUploadZone.vue";

export default {
  computed: {},
  components: {
    BlipFileUploadZone,
    LinkSelect,
    Card,
    BaseInput,
  },
  async created() {
    this.types = Object.entries(QuestType).map(([key, value]) => ({
      id: key,
      type: value,
    }));
    await this.getCategories();
    await this.getChallenges();
    if (this.$route.query.unitId) {
      this.unitId = this.$route.query.unitId;
    }
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getQuestById();
    }
  },
  data() {
    return {
      unitId: null,
      types: [],
      requirements: [],
      segments: [
        { segment: null, text: "전체" },
        { segment: 1, text: "1. NEW Fan" },
        { segment: 2, text: "2. Light Fan - Active" },
        { segment: 3, text: "3. Light Fan - Inactive" },
        { segment: 4, text: "4. Heavy Fan - Active" },
        { segment: 5, text: "5. Heavy Fan - Inactive" },
        { segment: 6, text: "6. At Risk" },
        { segment: 7, text: "7. Dormant" },
      ],
      data: {
        id: null,
        imageFileId: null,
        type: null,
        link: null,
        name: null,
        names: { ko: null, en: null, ja: null },
        point: null,
        star: null,
        randomPoint: null,
        count: null,
        maxCount: null,
        unitId: null,
        weight: null,
        pointCategoryId: null,
        segment: null,
        retryCount: null,
        superblipPoint: null,
        superblipStar: null,
        categoryId: null,
        photoCard: null,
        startTime: null,
        endTime: null,
        challengeId: null,
      },
      challenges: [],
      categories: [],
    };
  },
  watch: {
    "data.challengeId"(newVal) {
      const c = _.find(this.challenges, { id: newVal });
      this.data.link = `${Endpoints.blipSchema}inner?url=${Endpoints.missionUrl}/mission/challenge/${c.path}`;
    },
  },
  methods: {
    onFileIdChange(newFileIds) {
      this.data.imageFileId = newFileIds[0];
    },
    async getCategories() {
      const res = await this.$axios.get(`/quests/categories?unitId=${this.unitId}`);
      this.categories = [{ id: null, title: "없음" }, ...res.data.data];
    },
    async getChallenges() {
      const res = await this.$axios.get(`/fanLogs/challenges`);
      this.challenges = [{ id: null, title: "없음" }, ...res.data.data];
    },
    async getQuestById() {
      const res = await this.$axios.get(`/quests/${this.id}`);
      this.data = res.data.data;
      this.data.randomPoints = this.data.randomPoint ? JSON.parse(this.data.randomPoint) : [];
      this.data.names = this.data.names ? this.parseJsonSafely(this.data.names) : {};
    },

    async getArtistInfo(param) {
      this.data.unitId = param.unitId;
    },

    parseJsonSafely(input) {
      let parsed;

      try {
        parsed = JSON.parse(input);
      } catch (e) {
        console.error("Invalid JSON:", e);
        return null;
      }

      // 첫 번째 파싱 결과가 문자열이면 추가로 파싱
      if (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch (e) {
          console.error("Second JSON parse failed:", e);
          return null;
        }
      }

      return parsed;
    },

    getLink(param) {
      const linkModel = param.linkModel.split(".");
      if (linkModel.length === 1) {
        this[linkModel[0]] = param.value;
      } else if (linkModel.length === 2) {
        this[linkModel[0]][linkModel[1]] = param.value;
      } else if (linkModel.length === 3) {
        this[linkModel[0]][linkModel[1]][linkModel[2]] = param.value;
      }
    },

    addRandomPoint() {
      this.data.randomPoints.push({ value: 0, probability: 0 });
      this.$forceUpdate();
    },

    removeRandomPoint(index) {
      this.data.randomPoints.splice(index, 1);
      this.$forceUpdate();
    },

    async onSubmit() {
      if (parseInt(this.data.point, 10) === -1) {
        this.data.randomPoint = JSON.stringify(this.data.randomPoints);
        const totalPoint = this.data.randomPoints.reduce((sum, point) => {
          sum += parseInt(point.probability, 10);
          return sum;
        }, 0);
        if (totalPoint !== 100) {
          Toast.error("확률의 합은 100이여야 합니다");
          return;
        }
      }

      if (!this.data.type) {
        Toast.error("퀘스트 타입을 설정해주세요");
        return;
      }

      if (!this.data.name) {
        Toast.error("이름을 입력해주세요");
        return;
      }

      if (!this.data.link) {
        Toast.error("링크를 입력해주세요");
        return;
      }
      if (/\s/.test(this.data.link)) {
        Toast.error("공백을 제외하고 url만 입력해 주세요");
        return;
      }

      const nameString = JSON.stringify(this.data.names);
      await this.$axios.put(`/quests/${this.id}`, { nameString, ...this.data });
      Toast.success("수정되었습니다");
      this.$router.go(-1);
    },
    onSectionPaste(e) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      const pastedData = e.clipboardData.getData("text");

      try {
        const json = JSON.parse(pastedData);
        if (typeof json === "object") {
          this.data = json;
          this.data.names = this.data.names ? JSON.parse(this.data.names) : {};
        } else {
          window.Toast.error("잘못된 데이터입니다");
        }
      } catch (e) {
        window.Toast.error("잘못된 데이터입니다");
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
